var map = {
	"./l0.png": 408,
	"./l1.png": 409,
	"./l2.png": 410,
	"./l3.png": 411,
	"./l4.png": 412,
	"./l5.png": 413,
	"./l6.png": 414,
	"./l7.png": 415,
	"./l8.png": 416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 407;